import { jsx as _jsx } from "react/jsx-runtime";
import { HomePage } from "@/02-pages/home";
import { ErrorNotifier } from "@/06-shared/lib/errorNotifier";
import "./App.css";
import "./settings.css";
const App = () => {
    return (_jsx(ErrorNotifier, { children: _jsx(HomePage, {}) }));
};
export default App;
